<script lang="ts">
	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	import SettingGuide from '../../SettingGuide.svelte';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { devices } from 'src/stores/lists/devices';
	import { format } from 'svelte-i18n';

	export let device;

	let loading = false;

	let otherChannelId = device.id.indexOf('_') > -1 ? real_id(device.id) : device.id + '_1';

	let otherChannelName = $devices[otherChannelId].name;
	let otherChannelIndex = device.id.indexOf('_') > -1 ? 0 : 1;

	const setCalibration = async () => {
		loading = true;
		const res = await gen2Request(device, `em1.CalibrateFrom`, {
			id: device.channel,
			other_id: otherChannelIndex,
		});
		await onSettingsResponse(res, device, { danger: res?.errors?.message });
		loading = false;
	};
</script>

<SettingGuide
	text={$format('settings_guide_channel_calibration', {
		default: `Use "${otherChannelName}" as the reference to calibrate this channel. Connect both on the same line, with some load running.`,
		values: { otherChannelName },
	})}
/>

<Button size="m" {loading} width="full" on:click={setCalibration}>{$format('button_calibrate')}</Button>
